import api from '@/shared/api';

export const fetchPageContent = () => {
  return api.get('/page_contents')
  .then(({ data }) => {
    return data;
  });
};
